import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { approveDocumentRequest, approveDocumentResponse, approveDocumentFailure } from '../actions/approve-documents.actions';
import { IApproveUploadedDocsParams, IApproveDocumentsResponse, IApproveDocsRequest } from '../models/approve-document.model';

export const approveDocumentsFeatureKey = 'approveDocuments';

export interface ApproveDocumentsState {
  approveDocumentsRequest: IApproveDocsRequest;
  approveDocumentsSuccess: IApproveDocumentsResponse;
  approveDocumentsFailure: IGenericError<ErrorResponse>;
}

export const initialState: ApproveDocumentsState = {
  approveDocumentsRequest: undefined,
  approveDocumentsSuccess: undefined,
  approveDocumentsFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(approveDocumentRequest, (state, action) => ({
    ...state,
    approveDocumentsRequest: action.request
  })),
  on(approveDocumentResponse, (state, action) => ({
    ...state,
    approveDocumentsSuccess: action.response
  })),
  on(approveDocumentFailure, (state, action) => ({
    ...state,
    approveDocumentsFailure: action.error
  }))
);

export const getApproveDocumentsRequest = (state: ApproveDocumentsState) => state.approveDocumentsRequest;
export const getApproveDocumentsResponse = (state: ApproveDocumentsState) => state.approveDocumentsSuccess;
export const getApproveDocumentsFailure = (state: ApproveDocumentsState) => state.approveDocumentsFailure;
